import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	routes: [
		{ // 登录
			path: '/login',
			name: 'login',
			meta: {
				title: '登录',
				keepAlive: true,
			},
			component: ()=> import('@/views/login'),
		},
		{ // 注册
			path: '/regit',
			name: 'regit',
			meta: {
				title: '注册',
				keepAlive: true,
			},
			component: ()=> import('@/views/regit'),
		},
		{ // 忘记密码
			path: '/forget',
			name: 'forget',
			meta: {
				title: '忘记密码',
				keepAlive: true,
			},
			component: ()=> import('@/views/forget'),
		},
		{ // 首页
			path: '*',
			name: 'index',
			meta: {
				title: '首页',
				// keepAlive: true,
			},
			component: ()=> import('@/views/index'),
		},
		{ // 商城
			path: '/shop',
			name: 'shop',
			meta: {
				title: '商城',
				// keepAlive: true,
			},
			component: ()=> import('@/views/shop'),
		},
		{ // 搜索
			path: '/search',
			name: 'search',
			meta: {
				title: '搜索',
				// keepAlive: true,
			},
			component: ()=> import('@/views/search'),
		},
		{ // 商品详情
			path: '/detail',
			name: 'detail',
			meta: {
				title: '商品详情',
				// keepAlive: true,
			},
			component: ()=> import('@/views/detail'),
		},
		{ // 确认下单
			path: '/payment',
			name: 'payment',
			meta: {
				title: '确认下单',
				// keepAlive: true,
			},
			component: ()=> import('@/views/payment'),
		},
		{ // 云智饮片公司
			path: '/company',
			name: 'company',
			meta: {
				title: '云智饮片公司',
				// keepAlive: true,
			},
			component: ()=> import('@/views/company'),
		},
		{ // 产品中心
			path: '/product',
			name: 'product',
			meta: {
				title: '产品中心',
				// keepAlive: true,
			},
			component: ()=> import('@/views/product'),
		},
		{ // 产品详情
			path: '/product/detail',
			name: 'product-detail',
			meta: {
				title: '产品详情',
				// keepAlive: true,
			},
			component: ()=> import('@/views/product-detail'),
		},
		{ // 学术推广
			path: '/study',
			name: 'study',
			meta: {
				title: '学术推广',
				// keepAlive: true,
			},
			component: ()=> import('@/views/study'),
		},
		{ // 学术推广详情
			path: '/study/detail',
			name: 'study-detail',
			meta: {
				title: '学术推广',
				// keepAlive: true,
			},
			component: ()=> import('@/views/study-detail'),
		},
		{ // 个人资料
			path: '/my/info',
			name: 'my-info',
			meta: {
				title: '个人资料',
				// keepAlive: true,
			},
			component: ()=> import('@/views/my-info'),
		},
		{ // 账号认证
			path: '/my/account',
			name: 'my-account',
			meta: {
				title: '账号认证',
				// keepAlive: true,
			},
			component: ()=> import('@/views/my-account'),
		},
		{ // 账号安全
			path: '/my/safe',
			name: 'my-safe',
			meta: {
				title: '账号安全',
				// keepAlive: true,
			},
			component: ()=> import('@/views/my-safe'),
		},
		{ // 我的订单
			path: '/my/order',
			name: 'my-order',
			meta: {
				title: '我的订单',
				// keepAlive: true,
			},
			component: ()=> import('@/views/my-order'),
		},
		{ // 订单详情
			path: '/order/detail',
			name: 'order-detail',
			meta: {
				title: '订单详情',
				// keepAlive: true,
			},
			component: ()=> import('@/views/order-detail'),
		},
		{ // 我的收藏
			path: '/my/collect',
			name: 'my-collect',
			meta: {
				title: '我的收藏',
				// keepAlive: true,
			},
			component: ()=> import('@/views/my-collect'),
		},
		{ // 消息中心
			path: '/my/notice',
			name: 'my-notice',
			meta: {
				title: '消息中心',
				// keepAlive: true,
			},
			component: ()=> import('@/views/my-notice'),
		},
		{ // 消息详情/隐私政策/用户协议/关于中智
			path: '/articles',
			name: 'articles',
			meta: {
				title: '消息详情/隐私政策/用户协议/关于中智',
				// keepAlive: true,
			},
			component: ()=> import('@/views/articles'),
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js